import moment from "moment/moment";

export const getFormatedDate = (date) => {
  try{
    return moment(date.toDate()).format('DD/MM/YYYY - H:mm:ss')
  } catch (e) {
    return ''
  }
}